import { render } from "./PageEditor.vue?vue&type=template&id=7664c365"
import script from "./PageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PageEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/PageEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7664c365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7664c365', __exports__)) {
    api.reload('7664c365', __exports__)
  }
  
  module.hot.accept("./PageEditor.vue?vue&type=template&id=7664c365", () => {
    api.rerender('7664c365', render)
  })

}


export default __exports__